const configList = [
  //赢科
  {
    name: 'wincle.iesscloud.com',
    component: 'LoginWincle',
    title: '工商业储能数据云平台'
  },
  //三铁
  {
    name: 'sz-stx.cn',
    component: 'LoginSanTie',
    title: 'STE智慧储能云'
  },
  //赛唯
  {
    name: 'sav.iesscloud.com',
    component: 'LoginSaiWei',
    title: '赛唯E宝工商业储能云平台'
  },
  //明度
  {
    name: 'minedoo.iesscloud.com',
    component: 'LoginMingDu',
    title: '工商业储能云平台'
  },
  //驰硕
  {
    name: 'ems.sctyn.com',
    component: 'LoginChiShuo',
    title: '驰硕-智慧储能云平台'
  },
  //云基慧
  {
    name: 'ujoinwe.iesscloud.com',
    component: 'LoginUjoinWe',
    title: '云基慧-智慧储能云平台'
  },
  //鹏洲
  {
    name: 'pzcn.iesscloud.com',
    component: 'LoginPengZhou',
    title: '鹏洲储能云平台'
  },
  //大力
  {
    name: 'dali.iesscloud.com',
    component: 'LoginDaLi',
    title: '智慧储能管控平台'
  },
  //中汇芯能
  {
    name: 'zhess.iesscloud.com',
    component: 'LoginDefault',
    title: '中汇芯能智慧云平台'
  }
]
export default configList
